const SERVICE = 'market/product'

const listReviews = async (api, params) => api.setMethod().get().setService(SERVICE).process('reviews/:inventory_id', params)

const createReview = async (api, params, body) => api.setMethod().post().setService(SERVICE).setBody(body).process('reviews/:inventory_id', params)

const updateReview = async (api, params, body) => api.setMethod().put().setService(SERVICE).setBody(body).process('review/edit/:review_id', params)

const deleteReview = async (api, params) => api.setMethod().post().setService(SERVICE).process('reviews/edit/:review_id', params)

module.exports = {
  listReviews,
  createReview,
  updateReview,
  deleteReview
}
